module.exports = __webpack_public_path__ + "img/tk.9a878bbf.svg";